import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

export const RecipeContext = createContext();

const RecipeProvider = (props) => {

    const [ recipe, setRecipe ] = useState([]);
    const [ searchRecipe, setSearchRecipe ] = useState({
        name: '',
        category: ''
    });
    const [ consult, setConsult ] = useState(false);

    const { name, category } = searchRecipe;

    useEffect(() => {
        if(consult){
            const getRecipe = async () => {
                const url = `https://www.thecocktaildb.com/api/json/v1/1/filter.php?i=${ name }&c=${ category }`;
                const result = await axios.get(url);
                setRecipe(result.data.drinks);
            }
            getRecipe();
        }
    }, [searchRecipe]);

    return (
        <RecipeContext.Provider
            value={{
                recipe,
                setSearchRecipe,
                setConsult
            }}
        >
            { props.children }
        </RecipeContext.Provider>
    );
}

export default RecipeProvider;